import { getWishlistAction } from "@/actions/wishlist";
import { useMarket } from "@features/market/useMarket";
import useAuth from "@features/auth/hooks/useAuth";
import { useQuery } from "@tanstack/react-query";
import { getWishlistFromLocalStorage } from "../utils/localWishlistStorage";

export default function useWishlist() {
  const market = useMarket();
  const { token, user, loading } = useAuth();

  return useQuery({
    queryKey: ["wishlist", token ?? "guest"],
    enabled: !loading && (!user || Boolean(token)),
    queryFn: async () => {
      if (!token) {
        return getWishlistFromLocalStorage();
      }

      return getWishlistAction({
        token,
        pageSize: 1000,
        locale: market.locale,
      });
    },
  });
}
